import { Layout } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import LogoEbook from './assets/AlfaTeoriaPratica/logo_ebook.png';
import SiderEbook from './components/SiderEbook';
import CapaPlanoAnual from './modules/PlanoAnual/CapaPlanoAnual';
import Styled from './PlanoAnual2025.styled';
import ExpedientePlanoAnual from './modules/PlanoAnual/ExpedientePlanoAnual';
import SessionCIPlanoAnual from './modules/PlanoAnual/SessionCIP';
import SumaryPlanoAnual from './modules/PlanoAnual/SumaryPlanoAnual';
import SessionGeralPlanoAnual from './modules/PlanoAnual/1/SessionGeralPlanoAnual';
import SessionAbrangenciaPlanoAnual from './modules/PlanoAnual/2/SessionAbrangenciaPlanoAnual';
import SessionAnaliseMunicipios from './modules/PlanoAnual/3/pages/SessionAnaliseMunicipios';
import AmpliarImg from 'components/ampliarImg/AmpliarImg';

const navMenu = [
    {
        key: 1,
        label: 'Plano Anual Instituto Ayrton Senna',
    },
    {
        key: 2,
        label: 'Expediente',
    },
    {
        key: 3,
        label: 'Sumário',
    },
    {
        key: 4,
        label: '01 - Apresentação geral do plano anual',
    },
    {
        key: 5,
        label: '02 - Abrangência do plano',
    },
    {
        key: 6,
        label: '03 - Análise dos municípios',
        children: [
            { key: 7, label: '3.1 - Jaboatão dos guararape' },
            { key: 8, label: '3.2 - Macaé' },
            { key: 9, label: '3.3 - Maceió' },
            { key: 10, label: '3.4 - Natal' },
            { key: 11, label: '3.5 - Nova Iguaçu' },
            { key: 12, label: '3.6 - São Luís' },
        ],
    },
];

const { Content, Footer } = Layout;

const PlanoAnual2025 = () => {
    const [navActive, setNavActive] = useState<number>(1);

    const capa = useRef<any>(null);
    const expediente = useRef<any>(null);
    const cip = useRef<any>(null);
    const summary = useRef<any>(null);
    const sessionGeral = useRef<any>(null);
    const sessionAbrangencia = useRef<any>(null);
    const sessionAnalise3 = useRef<any>(null);
    const sessionAnalise3_1 = useRef<any>(null);
    const sessionAnalise3_2 = useRef<any>(null);
    const sessionAnalise3_3 = useRef<any>(null);
    const sessionAnalise3_4 = useRef<any>(null);
    const sessionAnalise3_5 = useRef<any>(null);
    const sessionAnalise3_6 = useRef<any>(null);

    const scrollToDiv = (divRef: any, abaAcitve: number) => {
        divRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

        setNavActive(abaAcitve);
    };

    useEffect(() => {
        const options: IntersectionObserverInit = {
            root: null, // Observa na viewport
            rootMargin: '0px',
            threshold: 0.1, // Trigger quando 10% da div está visível
        };

        const callback: IntersectionObserverCallback = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    switch (entry.target.id) {
                        case 'capa':
                            return setNavActive(1);
                        case 'expediente':
                            return setNavActive(2);
                        case 'summary':
                            return setNavActive(3);
                        case 'sessionGeral':
                            return setNavActive(4);
                        case 'sessionAbrangencia':
                            return setNavActive(5);
                        case 'sessionAnalise3':
                            return setNavActive(6);
                        case 'sessionAnalise3_1':
                            return setNavActive(7);
                        case 'sessionAnalise3_2':
                            return setNavActive(8);
                        case 'sessionAnalise3_3':
                            return setNavActive(9);
                        case 'sessionAnalise3_4':
                            return setNavActive(10);
                        case 'sessionAnalise3_5':
                            return setNavActive(11);
                        case 'sessionAnalise3_6':
                            return setNavActive(12);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        const refs = [
            capa,
            expediente,
            summary,
            sessionGeral,
            sessionAbrangencia,
            sessionAnalise3,
            sessionAnalise3_1,
            sessionAnalise3_2,
            sessionAnalise3_3,
            sessionAnalise3_4,
            sessionAnalise3_5,
            sessionAnalise3_6,
        ];
        refs.forEach(ref => {
            if (ref.current) {
                observer.observe(ref.current);
            }
        });

        return () => {
            refs.forEach(ref => {
                if (ref.current) {
                    observer.unobserve(ref.current);
                }
            });
            observer.disconnect();
        };
    }, []);

    return (
        <Styled.Container style={{ paddingTop: '80px' }}>
            <Layout style={{ height: '790px' }}>
                <SiderEbook
                    dados={navMenu}
                    navActive={navActive}
                    refs={[
                        capa,
                        expediente,
                        summary,
                        sessionGeral,
                        sessionAbrangencia,
                        sessionAnalise3,
                        sessionAnalise3_1,
                        sessionAnalise3_2,
                        sessionAnalise3_3,
                        sessionAnalise3_4,
                        sessionAnalise3_5,
                        sessionAnalise3_6,
                    ]}
                    handleClick={(divRef: any, abaAcitve: number) => {
                        if (abaAcitve === 1) scrollToDiv(divRef, 1);
                        if (abaAcitve === 2) scrollToDiv(divRef, 2);
                        if (abaAcitve === 3) scrollToDiv(divRef, 3);
                        if (abaAcitve === 4) scrollToDiv(divRef, 4);
                        if (abaAcitve === 5) scrollToDiv(divRef, 5);
                        if (abaAcitve === 6) scrollToDiv(divRef, 6);
                        if (abaAcitve === 7) scrollToDiv(divRef, 7);
                        if (abaAcitve === 8) scrollToDiv(divRef, 8);
                        if (abaAcitve === 9) scrollToDiv(divRef, 9);
                        if (abaAcitve === 10) scrollToDiv(divRef, 10);
                        if (abaAcitve === 11) scrollToDiv(divRef, 11);
                        if (abaAcitve === 12) scrollToDiv(divRef, 12);
                    }}
                    logoEbook={LogoEbook}
                />
                <Layout>
                    <Content style={{ margin: '24px 16px 0' }}>
                        <div
                            style={{
                                minHeight: 360,
                                height: '100%',
                                overflow: 'auto',
                                overflowX: 'hidden',
                                overflowY: 'scroll',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px',
                            }}
                        >
                            {/* Adicionar o corpo do ebook */}
                            <div ref={capa} id="capa" />
                            <CapaPlanoAnual />
                            <div ref={expediente} id="expediente" />
                            <ExpedientePlanoAnual />
                            <div ref={cip} id="cip" />
                            <SessionCIPlanoAnual />
                            <div ref={summary} id="summary" />
                            <SumaryPlanoAnual
                                listRefs={[
                                    sessionGeral,
                                    sessionAbrangencia,
                                    sessionAnalise3,
                                    sessionAnalise3_1,
                                    sessionAnalise3_2,
                                    sessionAnalise3_3,
                                    sessionAnalise3_4,
                                    sessionAnalise3_5,
                                    sessionAnalise3_6,
                                ]}
                                onClickItem={scrollToDiv}
                            />
                            <div ref={sessionGeral} id="sessionGeral" />
                            <SessionGeralPlanoAnual />
                            <div ref={sessionAbrangencia} id="sessionAbrangencia" />
                            <SessionAbrangenciaPlanoAnual />
                            <div ref={sessionAnalise3} id="sessionAnalise3" />
                            <SessionAnaliseMunicipios
                                ref3_1={sessionAnalise3_1}
                                ref3_2={sessionAnalise3_2}
                                ref3_3={sessionAnalise3_3}
                                ref3_4={sessionAnalise3_4}
                                ref3_5={sessionAnalise3_5}
                                ref3_6={sessionAnalise3_6}
                            />
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center', fontSize: 12 }}>
                        Material produzido pelo Instituto Ayrton Senna | 2025 <br />
                        <br /> Pode ser reproduzido, desde que mantida a menção de autoria
                        <br /> <br />
                        Este material conta com recurso de acessibilidade da Audima.
                    </Footer>
                </Layout>
            </Layout>
        </Styled.Container>
    );
};

export default PlanoAnual2025;
